import React from 'react';

import IslandIllustration from '@images/illustration/island@2x.png';
import LeftCloudIllustration from '@images/illustration/cloud-left@2x.png';
import CentralCloudIllustration from '@images/illustration/cloud-center@2x.png';
import RightCloudIllustration from '@images/illustration/cloud-right@2x.png';
import BalloonIllustration from '@images/illustration/balloon@2x.png';

import { StyledBalloon, StyledCloudCentral, StyledCloudLeft, StyledCloudRight, StyledIllustration, StyledIsland } from './styled';
import Image from 'next/image';

interface IIllustrationProps {
  children?: React.ReactNode;
}

const Illustration:React.FC<IIllustrationProps> = (props) => {
  return (
    <StyledIllustration>
      <StyledCloudLeft>
        <Image fill src={LeftCloudIllustration} alt='cloud' sizes="140px" />
      </StyledCloudLeft>
      <StyledCloudCentral>
        <Image fill src={CentralCloudIllustration} alt='cloud' sizes="111px" />
      </StyledCloudCentral>
      <StyledCloudRight>
        <Image fill src={RightCloudIllustration} alt='cloud' sizes="85px" />
      </StyledCloudRight>
      <StyledIsland>
        <Image priority fill src={IslandIllustration} sizes="424px" alt='island' />
      </StyledIsland>
      <StyledBalloon>
        <Image fill src={BalloonIllustration} sizes="32px" alt='balloon' />
      </StyledBalloon>
    </StyledIllustration>
  );
}

export default Illustration;
